import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0F0F0F] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <Link to="/" className="inline-block mb-4">
              <img src="/logo.png" alt="Martinez Auto Parts" className="h-14 w-auto" data-testid="footer-logo-img" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mt-3">Your trusted source for quality collision & body parts. New aftermarket, used OEM & refurbished parts for every make and model.</p>
          </div>
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-gray-300 mb-4" style={{ fontFamily: "'Chivo', sans-serif" }}>Shop</h4>
            <div className="space-y-2.5">
              <Link to="/products?category=bumpers" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Bumper Covers</Link>
              <Link to="/products?category=hoods" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Hoods</Link>
              <Link to="/products?category=fenders" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Fenders</Link>
              <Link to="/products?category=headlights" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Headlights</Link>
              <Link to="/products?category=mirrors" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Mirrors</Link>
              <Link to="/products?condition=used_oem" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Used OEM Parts</Link>
            </div>
          </div>
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-gray-300 mb-4" style={{ fontFamily: "'Chivo', sans-serif" }}>Account</h4>
            <div className="space-y-2.5">
              <Link to="/login" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Sign In</Link>
              <Link to="/register" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Create Account</Link>
              <Link to="/orders" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Order History</Link>
              <Link to="/cart" className="block text-gray-400 hover:text-[#F97316] text-sm transition-colors">Shopping Cart</Link>
            </div>
          </div>
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider text-gray-300 mb-4" style={{ fontFamily: "'Chivo', sans-serif" }}>Contact Us</h4>
            <div className="space-y-2.5">
              <p className="text-gray-400 text-sm">4720 N High St</p>
              <p className="text-gray-400 text-sm">Columbus, OH 43214</p>
              <a href="tel:7405648157" className="text-[#F97316] font-bold text-lg block" style={{ fontFamily: "'Chivo', sans-serif" }}>740-564-8157</a>
              <a href="mailto:mtzluis90@hotmail.com" className="text-gray-400 hover:text-[#F97316] text-sm block transition-colors">mtzluis90@hotmail.com</a>
              <a href="https://www.martinez-autoparts.com" target="_blank" rel="noopener noreferrer" className="text-[#F97316] hover:text-[#FB923C] text-sm block transition-colors font-semibold">www.martinez-autoparts.com</a>
              <p className="text-gray-500 text-xs">Mon-Fri: 8AM - 6PM EST</p>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-gray-500 text-xs">&copy; 2026 Martinez Auto Parts LLC. All rights reserved.</p>
          <div className="flex gap-4 text-gray-500 text-xs"><span className="hover:text-gray-300 cursor-pointer">Privacy</span><span className="hover:text-gray-300 cursor-pointer">Terms</span><span className="hover:text-gray-300 cursor-pointer">Accessibility</span></div>
        </div>
      </div>
    </footer>
  );
}
